const formatExtraProjectNumber = (projectNumber) => projectNumber;
export default formatExtraProjectNumber;
